export const _en = {
    code: {
        label: "Code"
    },
    beginHour: {
        label: "Begin hour"
    },
    endHour: {
        label: "Finish hour"
    },
    refSeasonId: {
        label: "Season"
    },
    dialog: {
        add: {
            title: "Add time code",
            buttons: {
                save: "Save",
                cancel: "Cancel"
            }
        }
    }

};

export const _fr = {
    code: {
        label: "Code"
    },
    beginHour: {
        label: "Heure de début"
    },
    endHour: {
        label: "Heure de fin"
    },
    refSeasonId: {
        label: "Saison"
    },
    dialog: {
        add: {
            title: "Ajout d'un code horaire",
            buttons: {
                save: "Sauvegarder",
                cancel: "Annuler"
            }
        }
    }

};